import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Components/SideBar/sideBar"; // Assuming your sidebar component
import { FaBars, FaTimes } from "react-icons/fa";
import "./adminLayout.scss";

const AdminLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // UX Fix: Automatically close the mobile sidebar when a route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // UX Fix: Lock the background scroll when the mobile drawer is open
  useEffect(() => {
    if (isMobileMenuOpen && window.innerWidth < 1024) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="v-adm-layout-wrapper">
      {/* 1. MOBILE TOP APP BAR (Hidden on Desktop) */}
      <header className="v-adm-layout-mobile-header">
        <div className="brand-zone">
          <img
            src="/images/SV-logo2.png"
            alt="SVGOLD Admin"
            className="admin-logo"
          />
          <span className="admin-badge">ERP</span>
        </div>
        <button
          className="hamburger-btn"
          onClick={() => setIsMobileMenuOpen(true)}
        >
          <FaBars />
        </button>
      </header>

      {/* 2. MOBILE BACKDROP (Hidden on Desktop) */}
      <div
        className={`v-adm-layout-backdrop ${isMobileMenuOpen ? "active" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      {/* 3. SMART SIDEBAR (Fixed on Desktop, Drawer on Mobile) */}
      <aside
        className={`v-adm-layout-sidebar ${isMobileMenuOpen ? "open" : ""}`}
      >
        <div className="sidebar-mobile-close">
          <img
            src="/images/SV-logo2.png"
            alt="SVGOLD"
            className="mobile-logo-inside"
          />
          <button
            className="close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FaTimes />
          </button>
        </div>

        {/* Your imported Sidebar component renders here */}
        <div className="sidebar-content-wrapper">
          <Sidebar />
        </div>
      </aside>

      {/* 4. MAIN WORKSPACE (Scrollable Data Area) */}
      <main className="v-adm-layout-main" id="erp-main-scroll-area">
        <div className="v-adm-workspace-inner fade-in">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
